import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Spread string-labelled graph nodes into positioned nodes for MiniGraph
const YS = [30, 72, 46, 92, 58];
export function normalizeGraph(graph) {
  if (!graph || !Array.isArray(graph.nodes)) {
    return { nodes: [], edges: [] };
  }
  const positioned = graph.nodes.map((n, i, arr) => {
    const label = typeof n === "string" ? n : n.label;
    const count = arr.length;
    const x = 34 + (i * (200 / Math.max(count - 1, 1)));
    return {
      id: String(i),
      label,
      x,
      y: YS[i % YS.length],
      active: i === 0 || i === count - 1,
    };
  });
  const edges = (graph.edges || [])
    .filter((e) => Array.isArray(e) && e.length === 2)
    .map(([a, b]) => [String(a), String(b)]);
  return { nodes: positioned, edges };
}

function normalizeLink(link, idx) {
  return {
    id: `cl-${String(idx + 1).padStart(2, "0")}`,
    title: link.title || "Untitled source",
    summary: link.summary || "",
    concepts: link.concepts || [],
    reliability: Math.max(0, Math.min(100, Math.round(link.reliability ?? 80))),
    source: link.source || "unknown source",
    graph: normalizeGraph(link.graph),
  };
}

export async function cognitiveSearch({ query, reasoning, attitude, language }) {
  const { data } = await axios.post(
    `${API}/search`,
    { query, reasoning, attitude, language },
    { timeout: 120000 }
  );
  return {
    recognized_intent: {
      label: data.recognized_intent?.label || "General Inquiry",
      confidence: data.recognized_intent?.confidence ?? 0.9,
      entities: data.recognized_intent?.entities || [],
    },
    cognitive_summary: data.cognitive_summary || "",
    links: (data.links || []).map(normalizeLink),
    concept_clusters: (data.concept_clusters || []).map((c) => ({
      label: c.label,
      count: c.count,
    })),
  };
}
